<template>
    <div>
        <div class="contents">
            <div class="tw-w-full">
                <div class="tw-flex tw-flex-wrap -tw-mx-3">
                    <div class="tw-w-full tw-px-3">
                        <div class="wl-page-header">
<h1 class="wl-page-title">Detail pesan masuk</h1>
                        </div>
                    </div>
                </div>
                <div class="tw-flex tw-flex-wrap -tw-mx-3">
                    <div class="tw-w-full tw-px-3">
                        <div v-if="!isLoading" class="wl-panel tw-w-full tw-mb-8">
                            <label for="">Pengirim</label>
                            <input type="text" class="wl-input" v-model="incoming.number" readonly v-phone >
                            <br>
                            <label for="">Tujuan</label>
                            <input type="text" class="wl-input" :value="device.name + ' (' + device.status + ')'" readonly>
                            <br>
                            <label for="">Pesan</label>
                            <textarea class="wl-textarea" cols="30" rows="10" v-model="incoming.text" readonly />
                            <br>
                            <label for="">Diterima pada</label>
                            <input type="text" class="wl-input" :value="convertDateToLocal(incoming.created_at)" readonly>
                            <br>
                        </div>
                        <div v-else class="wl-panel tw-w-full tw-mb-8">
                            <center>
                                <div class="wl-spinner spinner" role="status"></div>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
      data() {
        return {
            id: '',
            incoming: {},
            device: {},
            history: [],
            isLoading: true,
        };
      },
      mounted() {
        this.loadData()
        this.id = this.$route.query.id
      },
      methods: {
        convertDateToLocal(date){
                return moment.utc(date).local().format("YYYY-MM-DD HH:mm:ss")
        },
        async loadData(){
            try{
                let id = this.$route.query.id
                let detail = await this.$store.dispatch("incoming_detail", { id: id })
                this.incoming = detail.data.data.incoming
                this.device = this.incoming.device
                this.isLoading = false
            }catch(err){
                this.$toast.error(err.response.data.message)
                this.$router.push("/incoming")
            }
        },
        addVariable() {
            this.form.variable.push({id: this.form.variable.length + 1, value: ""});
        },
        deleteVariable() {
            this.form.variable.splice(-1)
        },
        preselectedGroup(){
            for (let i = 0; i < this.g.rows.length; i++) {
                let index = this.form.joined_group.indexOf(this.g.rows[i].id)
                if(index != -1){
                    this.$set(this.g.rows[i], 'vgtSelected', true);
                }
            }
        },
        setPayloadGroup(){
            let payload = {
                contact_id: this.$route.query.id,
                add: [],
                remove: []
            }

            let selected = this.$refs['group-table'].selectedRows
            let old = this.form.joined_group

            //ADD
            for(let i = 0;i < selected.length;i++){
                if(old.indexOf(selected[i].id) == -1){
                    payload.add.push(selected[i].id)
                }
            }

            //REMOVE
            for(let i = 0;i < old.length;i++){
                let status = false
                for(let j = 0;j < selected.length;j++){
                    if(old[i] == selected[j].id) status = true
                }

                if(status == false){
                    payload.remove.push(old[i])
                }
            }
            
            return payload
        },
        async updateContact(){
            try{
                let response = await this.$store.dispatch('contact_update', this.form)
                this.$toast.success(response.data.message);
            }catch(err){
                this.$toast.error(err.response.data.message);
            }
        },
        async saveGroup(){
            let payload = await this.setPayloadGroup()

            try{
                let response = await this.$store.dispatch('group_update_by_contact', payload)
                this.$toast.success(response.data.message);
                this.loadData()
            }catch(err){
                this.$toast.error(err.response.data.message);
            }
        }
      },
    };
</script>